import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { useEffect, useState } from "react";
import { Divider, Modal, Box, Button } from "@mui/material";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import HomeScreen from "../components/Home/HomeScreen";
import { useAuth0 } from "@auth0/auth0-react";
import axiosInstance from "../components/common/AxiosInterceptor";
import {
  getLoggedInUserDetails,
  createUserAudit,
  createAdminAudit,
  getRoleOfInternalUser,
  getRoleOfExternalUser,
  storeUserRoleInDb
} from "../components/common/constants/globalconstants";
import AdminHomeScreen from "../components/Home/AdminHomeScreen";
import { useDispatch, useSelector } from "react-redux";
import {
  storeAccessToken,
  storeUserDetails,
  updateCareFacility,
  storeIdTokenClaims,
  updateCareFacilityList,
  storeUserRole
} from "../action";
import {convertFromUTCToEST, getDefaultCareFacility} from "../components/common/Utils";
import UAParser from 'ua-parser-js';
import { addDays } from "date-fns";
import {style} from "../components/login/UserLogin";
import DraggableProfilePanel from "../components/common/DraggableProfilePanel";
import ErrorModal from "../components/common/ErrorModal";
let isAdmin = false;

function Home() {
  const [loading, setloading] = useState(true); //true
  const [userAuditReq, setUserAuditReq] = useState({});
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const {
    user,
    isAuthenticated,
    isLoading,
    getAccessTokenSilently,
    getIdTokenClaims
  } = useAuth0();
  const dispatch = useDispatch();

  const [myuser, setmyuser] = useState({});
  const [showMsgModal, setShowMsgModal] = useState(false);
  const [expDate, setExpDate] = useState("");
  const storetoken = useSelector((state) => state.storetoken);
  const storeuser = useSelector((state) => state.storeuser);
  const carefacilitydetails = useSelector((state) => state.carefacilitydetails);
  
  useEffect(() => {
    let newtoken = getAccessTokenSilently();
    const claims = getIdTokenClaims();
    newtoken.then((res) => {
      dispatch(storeAccessToken(res));
    });

    claims.then((claim) => {
      dispatch(storeIdTokenClaims(claim));
    });
  }, [isAuthenticated]);

  let abc = useAuth0();
  useEffect(() => {
    isAuthenticated && console.log("");
    dispatch(storeUserDetails(user));
    setmyuser(user);
  }, [isAuthenticated, myuser]);

   
  useEffect(() => {
    let request={};
     const parser = new UAParser();
     const browser = parser.getBrowser();

    if(user && user.updated_at!==null && user.updated_at!==undefined && user.updated_at!==""){
     request ={
      userName: user.name? user.name :"",
      //logDate: user.updated_at? getUTCUpdatedAtDateForLog(user.updated_at): "",
      logDate: user.updated_at? convertFromUTCToEST(user.updated_at) :"",
      userType: user.usertype==="external"? "CareFacility User": user.usertype==="internal" ? "Webster Admin":"",
      browserName: browser.name? browser.name: "",
      browserVersion:  browser.version?  browser.version:""
    }
    if(Object.keys(request).length !==0)
      {
        setUserAuditReq(request);
      }
    }
   }, [user]); 

   useEffect(()=>{
      if(Object.keys(userAuditReq).length!==0 && storetoken !== "" && storetoken !== undefined && storetoken !== "storeToken"
      && storeuser !== "" && storeuser !== null && storeuser !== undefined && storeuser.email !== "email"){
        InsertAuditRequest();
      }
   },[userAuditReq, storetoken])

   const InsertAuditRequest =async() =>{
    try{
      let response;
      if(isAdmin){
        response = await axiosInstance.post(`${createAdminAudit}`,JSON.stringify(userAuditReq));
      }else{
        response = await axiosInstance.post(`${createUserAudit}`,JSON.stringify(userAuditReq));
      }      
        if (response && response.data.isSuccess) {
          seterrormodalOpen(false);          
        } else if (response && !response.data.isSuccess && response.data.result!=="Already User Name exists!") {
          seterrormodalOpen(true);
        }

        if(response !== "" && response !== null && response !== undefined){
          if(isAdmin){
            storeIntAndExtUserRole(); 
          }
          if(!isAdmin){
            getUserRole();
          }
        }
    }
    catch (error) {
      console.log(error);
      seterrormodalOpen(true);
    }
   }

  useEffect(() => {
    if (storetoken !== "" && storetoken !== "storeToken" 
      && storeuser !== undefined && storeuser.email !== "email" && !isAdmin && Object.keys(carefacilitydetails).length===0) {

      const fetchCareFacilityDetails = async() => {
        try{
          const data = await axiosInstance.get(`${getLoggedInUserDetails}?userName=${storeuser.email}`);
          dispatch(updateCareFacilityList(data.data.result));
          const defaultData = getDefaultCareFacility(data.data.result);
          dispatch(updateCareFacility(defaultData));
          setloading(false);
        }
        catch(error) {
          console.log("Error occured while getting carefacility details")
          setloading(false);
        }
      };

    const timer = setTimeout(() => {
        fetchCareFacilityDetails();      
    }, 1500);
    return () => clearTimeout(timer);
  } else {
    setloading(false);
  }
  }, [storeuser]);

  useEffect(()=>{
    const msgShown = sessionStorage.getItem("ResetAlertShownFlag");
    if(!msgShown && msgShown === null && Object.keys(user).length !== 0){
      checkForPasswordExpiry();
      //sessionStorage.setItem("ResetAlertShownFlag", "true");
    }
  },[])

  {/*useEffect(() => {
    if(isAuthenticated && storetoken !== "" && storetoken !== null 
      && storeuser !== undefined && storeuser !== "" 
      && storetoken !== undefined && auditCreated){
      if(isAdmin){
        storeIntAndExtUserRole(); 
      }
      if(!isAdmin){
        getUserRole();
      }
    } 
  }, [storetoken, auditCreated]);*/}


  const getUserRole = async() =>{
      try {
        let response;
        const request = {
          userName: storeuser.email
        }
        if(isAdmin){
          response = await axiosInstance.post(`${getRoleOfInternalUser}`,JSON.stringify(request));
        }
        else if(!isAdmin){
          response = await axiosInstance.post(`${getRoleOfExternalUser}`,JSON.stringify(request));
        }

        if(response.data.isSuccess){
           const role = response.data.result && response.data.result.roleName;
           dispatch(storeUserRole(role));
           seterrormodalOpen(false);
        }
        else if(!response.data.isSuccess){
          seterrormodalOpen(true);
        }
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
    }
    }

  const storeIntAndExtUserRole = async() =>{
      try {
        const request = {
          userName: user && user.email,
          fullName: user && user.name
        }
          const response = await axiosInstance.post(`${storeUserRoleInDb}`,JSON.stringify(request));
        if(response.data.isSuccess){
           getUserRole(); 
           seterrormodalOpen(false);
        }
        else if(!response.data.isSuccess){
          seterrormodalOpen(true);
        }
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
    }
    }

  const checkForPasswordExpiry=()=>{
    if(user.last_password_reset && user.usertype === "external" && user.password_rotation_period) {
      const convertedLastRstdt = convertFromUTCToEST(user.last_password_reset);
      const lastResetdate = new Date(convertedLastRstdt);
      const newLastRstDate = addDays(lastResetdate, user.password_rotation_period);
      const currentDate = new Date();
      const diffTime = Math.abs(new Date(currentDate) - new Date(newLastRstDate));
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      if(diffDays <= 5){
        setShowMsgModal(true);
        const dateToBeShown = new Date(newLastRstDate);
        const expDateToBeShown =`${(dateToBeShown.getMonth() + 1).toString().padStart(2, '0')}/${dateToBeShown.getDate().toString().padStart(2, '0')}/${dateToBeShown.getFullYear()} ${dateToBeShown.getHours().toString().padStart(2, '0')}:${dateToBeShown.getMinutes().toString().padStart(2, '0')}:${dateToBeShown.getSeconds().toString().padStart(2, '0')}`;
        setExpDate(expDateToBeShown);
      }
    }
  }

  const handleCloseModal = (event, reason) =>{
    if(reason === "backdropClick" || reason === "escapeKeyDown"){
      return;
    } 
    setShowMsgModal(false);
    sessionStorage.setItem("ResetAlertShownFlag", "true");
  }

  if (isLoading && user !== undefined) {
    return <div>Loading ...</div>;
  }

  if (user !== undefined) {
    isAdmin = user["usertype"] === "internal" ? true : false;
  }

  return (
    <div style={{ height: "100%", margin: "0", padding:"0"}}>
    <div>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress sx={{ color: "white" }} />
            <span>
              {" "}
              &nbsp;&nbsp;&nbsp;&nbsp;Please Wait Loading Website...{" "}
            </span>
          </Backdrop>
        </>
      )}
      <div style={{display: "flex",flexDirection: "column", minHeight: "100vh", width: "100%"}}>
      {/* <Grid container> */}
        <Header
          isVisible={true}
          buttonsVisible={isAdmin ? false : true}
          user={user}
        />
        <Divider orientation="horizontal" sx={{ width: "100%" }} />

        {!loading && (
          <div style={{flex: "1"}}>
            {!isAdmin ? <DraggableProfilePanel/> : null}
            {isAdmin ? <AdminHomeScreen/> :null}
            {!isAdmin ? <HomeScreen/> :null}
           
          </div>
        )}
        <div style={{ position:"relative", bottom:"0"}}>
        <Footer />
        </div>
      {/* </Grid> */}
       <Modal open={showMsgModal} onClose={handleCloseModal} disableBackdropClick>
          <>
              <Box sx={style}>
                <p style={{fontSize:"16px", color:"#002d82", fontWeight:"bold"}}>Password Expiry</p>
              <Divider orientation="horizontal" sx={{ width: "100%" }} />
                <p style={{textAlign:"center", align:"center"}}>
                Password is expiring on <b style={{fontWeight:"500px"}}>{expDate}</b> <br></br>
                Reset your password from login page using Forgot Password.
                </p>
                <Button
                  id="modal-userlogin-btn"
                  variant="contained"
                  onClick={handleCloseModal}
                >
                  Close
                </Button>
              </Box>
          </>
        </Modal>
      </div>
    </div>
    {errormodalopen && (
			<ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
		  )}
    </div>
  );
}

export default Home;
